import { render, staticRenderFns } from "./CheckLists.vue?vue&type=template&id=022a21f9&scoped=true"
import script from "./CheckLists.vue?vue&type=script&lang=js"
export * from "./CheckLists.vue?vue&type=script&lang=js"
import style0 from "./CheckLists.vue?vue&type=style&index=0&id=022a21f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a21f9",
  null
  
)

export default component.exports